import { Alert, Input } from "antd";
import Clock from "../../../../utils/LiveClock";
import { useAuth } from "../../../../authentication/authHelpers";
import dayjsTZ from "../../../../utils/dayjs";
import { useMediaQuery } from "react-responsive";
import { eventTracker } from "../../../../utils/eventTracker";
import { showErrorMsg } from "../../../Documentation/utils/Messages";

const { TextArea } = Input;

const HOURLY_PAYROLL = "Page bazuar ne ore";

function ClockInActive({
  editedTime,
  setShowConfirm,
  setShowYesterday,
  whiteListError,
  notes,
  onShiftNote,
}) {
  const auth = useAuth();
  const isMobileView = useMediaQuery({
    query: "(max-width: 450px)",
  });

  const employeeId = auth?.employeeId;
  const currEmployeePayroll = auth.employee?.employeePayrollType;
  const isHourly = currEmployeePayroll === HOURLY_PAYROLL;

  let blockReason = null;
  if (!employeeId) {
    blockReason =
      "Nuk u gjet një profil punonjësi i lidhur me këtë llogari. Kontaktoni administratorin.";
  } else if (!isHourly) {
    blockReason =
      "Ju nuk mund të filloni turnin pasi nuk keni një pagë të bazuar në orë.";
  } else if (whiteListError) {
    blockReason =
      whiteListError +
      " Ju lutemi kontaktoni menaxherin tuaj për të filluar turnin.";
  }

  const handleClockIn = () => {
    if (blockReason) {
      showErrorMsg({ content: blockReason });
      return;
    }
    setShowConfirm(true);
    eventTracker("Clock In", "click", "Opened clockin modal");
    !isMobileView && navigator.clipboard.writeText(dayjsTZ().format("HH:mm"));
  };

  return (
    <div className="clock-in-active">
      <div className="time-indicator" />
      <div className="clock-in-content">
        <div className="actionful">
          <div className="start-shift-cont">
            <span className="welcomeMessage">
              <h1>Përshëndetje!</h1>
            </span>
            {blockReason ? (
              <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 12, textAlign: "left", maxWidth: 280 }}
                message={blockReason}
              />
            ) : null}
            <span
              className="start-shift-btn"
              style={{
                width: "160px",
                opacity: blockReason ? 0.55 : 1,
                cursor: blockReason ? "not-allowed" : "pointer",
              }}
              onClick={handleClockIn}
            >
              Fillo Turnin
            </span>
            <div className="currentTime">
              Ora Tani:{" "}
              <Clock
                format={"HH:mm"}
                ticking={true}
                timezone={"Europe/Tirane"}
              />
            </div>
            <span
              className="yesterday-shift-btn"
              style={{ textAlign: "center" }}
              onClick={() => setShowYesterday(true)}
            >
              Shikoni prezencën në të kaluarën{" "}
            </span>
          </div>
        </div>
      </div>
      {editedTime && (
        <div className="justify-note-wrapper" style={{ marginTop: "10px" }}>
          <TextArea
            value={notes?.clockInNote}
            onChange={(e) => onShiftNote(e, "clockInNote")}
            classname="justify-note"
            placeholder="Shkruaj një shënim këtu..."
            autoSize={{ minRows: 2, maxRows: 2 }}
          />
        </div>
      )}
    </div>
  );
}

export default ClockInActive;
